import * as $ from 'jquery';
import { LarchSys } from '../utils/larchSys';


export function objectFitFeature(larchSys: LarchSys) {

    // polyfill for: img { object-fit: cover; }
    if ('objectFit' in document.documentElement.style === false) {
        $('.img-fit').each(function () {
            const img = this as any as HTMLImageElement;

            var type = 'cover';
            if (/img-fit-contain/ig.test(img.className)) {
                type = 'contain';
            }

            const div = document.createElement('div');
            div.className = `object-fit-ie-fix lazyload img-${type} ${img.className}`;
            div.setAttribute('data-bgset', img.getAttribute('data-srcset') || img.getAttribute('data-src'));

            img.parentNode.replaceChild(div, img);
        });
    }

}